import { useState, useEffect } from 'react'
import { filter, toLower } from '@/utils/lodash'
import useProperties, { KindOfPage } from '@/hooks/useProperties'
import { usePublicMarketplace, useSubdomain } from './usePublicPages'
import { getPublicMarketplaceView } from './getPublicMarketplaceView'

/**
 * Custom hook for public marketplace page state and data management
 */
export const usePublicMarketplacePage = (props) => {
  const { marketplace, sold = false } = props
  const [activeTab, setActiveTab] = useState(() =>
    getPublicMarketplaceView(localStorage.getItem('view')),
  )
  const [showMenu, setShowMenu] = useState(true)
  const [openAccept, setOpenAccept] = useState(false)
  const [openReject, setOpenReject] = useState(false)

  const { subdomainParam } = useSubdomain()
  const marketplaceUrl = marketplace ? marketplace.url : null

  const [
    {
      properties,
      count,
      currentPageProperties,
      marketPlaceData,
      loadingMarketPlaceData,
      marketPlaceError,
      ordering,
      page,
      selected,
      search,
      marketplaceSelected,
    },
    {
      selectAll,
      selectProperty,
      getSearchResults,
      getFilteredProperties,
      fetchMoreProperties,
      setOrdering,
      selectMarketplaceProperty,
      setMarketplaceSelected,
      handlePageChange,
      handleRequestSort,
      setSelected,
      setPage,
    },
  ] = useProperties({
    ...props,
    kind: KindOfPage.PUBLIC_MARKETPLACE,
    marketplace: marketplaceUrl,
  })

  // Filter properties based on expiration date and sold status
  let unfilteredProperties = !marketplaceUrl
    ? filter(
        marketPlaceData?.marketplaceProperties?.properties,
        (property) =>
          new Date(property?.marketplaces?.expirationDate).getTime() >
          Date.now(),
      )
    : marketPlaceData?.marketplaceProperties?.properties

  unfilteredProperties = sold
    ? filter(
        unfilteredProperties,
        (property) => toLower(property?.status || '') === 'sold',
      )
    : filter(
        unfilteredProperties,
        (property) => toLower(property?.status || '') !== 'sold',
      )

  const cursor =
    marketPlaceData?.marketplaceProperties?.cursor || null

  // Event handlers
  const handleMenu = () => {
    setShowMenu(false)
  }

  const isSmallWindow = window.innerWidth < 950
  const [isSidebarMenuOpen, setIsSidebarMenuOpen] = useState(false)
  const toggleSidebarMenu = () =>
    setIsSidebarMenuOpen(!isSidebarMenuOpen)

  return {
    // Data
    properties,
    count,
    currentPageProperties,
    marketPlaceData,
    unfilteredProperties,
    cursor,
    marketplaceUrl,
    subdomainParam,

    // State
    activeTab,
    showMenu,
    openAccept,
    openReject,
    isSidebarMenuOpen,
    ordering,
    page,
    selected,
    search,
    marketplaceSelected,

    // Loading states
    loadingMarketPlaceData,
    marketPlaceError,

    // Event handlers
    setActiveTab,
    handleMenu,
    setOpenAccept,
    setOpenReject,
    toggleSidebarMenu,
    selectAll,
    selectProperty,
    getSearchResults,
    getFilteredProperties,
    fetchMoreProperties,
    setOrdering,
    selectMarketplaceProperty,
    setMarketplaceSelected,
    handlePageChange,
    handleRequestSort,
    setSelected,
    setPage,
  }
}
